import React from "react"
import types from "prop-types"
import clsx from "clsx"

const CountBadge = ({ count, className = "" }) => (<span className={clsx("count-badge", className)}>{count}</span>)

CountBadge.propTypes = {
  className: types.string,
  count: types.number.isRequired,
}

export default CountBadge
